import { useEffect, useState } from 'react';
import { getServerOrCurrentDateTime } from 'services/utils';

const LiveDateTime = (props) => {
    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    useEffect(() => {
      let intervalId = null;
      let isMounted = true;

      const startClock = () => {
        intervalId = setInterval(() => {
          setCurrentDateTime((prevDateTime) => new Date(prevDateTime.getTime() + 1000));
        }, 1000);
      };

      const syncServerDateTime = async () => {
        try {
          const serverDate = await getServerOrCurrentDateTime();
          const isValidServerDate = !Number.isNaN(serverDate.getTime());
          if (isMounted && isValidServerDate) {
            setCurrentDateTime(serverDate);
          }
        } catch (error) {
          // Keep local time fallback when server time API fails.
        } finally {
          if (isMounted) {
            startClock();
          }
        }
      };

      syncServerDateTime();

      return () => {
        isMounted = false;
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }, []);

    const formattedDate = currentDateTime.toLocaleDateString();
    const formattedTime = currentDateTime.toLocaleTimeString();

    return (
      <div>
        <p>{formattedDate} {formattedTime}</p>
      </div>
    );
};

export default LiveDateTime;
